if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
  const button = mediaToSwitch.querySelector('button');

  if (!button) return;

  button.addEventListener('click', () => {
    this.setActiveMedia(mediaToSwitch.dataset.target, false);

    this.selectVariantFromMedia(mediaToSwitch);
  });
});
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }
selectVariantFromMedia(mediaElement) {
  const variantId = mediaElement.dataset.variantId;

  if (!variantId) return;

  const productInfo = this.closest('product-info');

  if (!productInfo) return;

  const variantSelectors = productInfo.querySelector('variant-selects');

  if (!variantSelectors) return;

  const options = JSON.parse(
    mediaElement.dataset.variantOptions || '[]'
  );

  if (!options.length) return;

  const fieldsets = variantSelectors.querySelectorAll(
    'fieldset.product-form__input'
  );

  if (!fieldsets.length) return;

  /*
   * First select ALL variant options.
   * Do not trigger change events yet.
   */
  options.forEach((optionValue, index) => {
    const fieldset = fieldsets[index];

    if (!fieldset) return;

    const radio = Array.from(
      fieldset.querySelectorAll('input[type="radio"]')
    ).find((input) => input.value === optionValue);

    if (radio) {
      radio.checked = true;
    }

    const select = fieldset.querySelector('select');

    if (select) {
      const option = Array.from(select.options).find(
        (item) => item.value === optionValue
      );

      if (option) {
        select.value = optionValue;
      }
    }
  });

  /*
   * Now trigger ONE change event only.
   * At this point all options are already selected.
   */
  const lastFieldset = fieldsets[options.length - 1];

  if (!lastFieldset) return;

  const lastRadio = lastFieldset.querySelector(
    `input[type="radio"]:checked`
  );

  if (lastRadio) {
    lastRadio.dispatchEvent(
      new Event('change', { bubbles: true })
    );
    return;
  }

  const lastSelect = lastFieldset.querySelector('select');

  if (lastSelect) {
    lastSelect.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }
}
      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
